import { t } from "../../../../services";
import { strCode } from "../../../../consts";

import { FlexContainers, Paragraph2, SVG, WrapperContainer } from "../../../../components";
import { WarningMsgWrapper } from "./styled";
import PropTypes from "prop-types";

const WarningMsg = ({ missingKeysCount }) => {
  return (
    <WarningMsgWrapper>
      <WrapperContainer Container={FlexContainers.FlexRowStart} alignItems="start">
        <SVG.ExclamationMark />

        <WrapperContainer
          Container={FlexContainers.FlexColumnBetween}
          gap={4}
          alignItems="start"
          pl={16}>
          <Paragraph2 dangerouslySetInnerHTML={{ __html: t(strCode.SOME_KEYS_ARE_MISSING) }} />
          <Paragraph2
            dangerouslySetInnerHTML={{
              __html: t(strCode.SOME_KEYS_ARE_MISSING_INFO, { count: missingKeysCount })
            }}
          />
        </WrapperContainer>
      </WrapperContainer>
    </WarningMsgWrapper>
  );
};

WarningMsg.propTypes = {
  missingKeysCount: PropTypes.number.isRequired
};

export default WarningMsg;
